export default {
  state: () => ({
    testKey: "test core value",
  }),
  mutations: {},
  actions: {},
  getters: {},
};
